<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 20 24"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        id="e6bu8hzksa"
        d="M19 12c.552 0 1 .448 1 1v2c0 2.761-2.239 5-5 5H3.414l2.293 2.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-4-4-.073-.082-.007-.008.08.09c-.036-.035-.068-.073-.097-.112-.018-.024-.034-.049-.05-.074l-.024-.042c-.01-.018-.02-.037-.028-.056l-.023-.052-.021-.06-.014-.045-.016-.065-.009-.053C.004 19.1 0 19.051 0 19l.004.09L0 19.02V19v-.02c0-.022.002-.046.004-.07l.007-.059.01-.052c.004-.022.009-.043.015-.065l.014-.046.021-.06.023-.051.03-.061.022-.037c.02-.03.04-.061.062-.09l.002-.002c.028-.035.054-.066.083-.094l4-4c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L3.414 18H15c1.598 0 2.904-1.249 2.995-2.824L18 15v-2c0-.552.448-1 1-1zM15.613.21l.094.083 4 4c.029.028.055.059.08.09l.017.022c.018.024.034.049.05.074l.021.037c.011.02.022.04.031.06l.023.053.021.06.014.045.016.065.009.053.008.073.001.015.001.027L20 5v.034l-.004.051c-.001.022-.004.043-.007.064l-.01.052c-.004.022-.009.043-.015.065l-.014.046-.021.06-.023.051-.03.061-.022.037c-.016.025-.032.05-.05.074l-.025.03c.004-.002.002-.001.001 0l-.013.015-.01.013-.034.036-.016.018-4 4c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L16.585 6H5C3.402 6 2.096 7.249 2.005 8.824L2 9v2c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L0 11V9c0-2.689 2.122-4.882 4.783-4.995L5 4h11.585l-2.292-2.293c-.36-.36-.388-.928-.083-1.32l.083-.094c.36-.36.928-.388 1.32-.083zm4.166 5.415l-.056.064.044-.049.012-.015z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-transfers",
  components: {},
})
export class IconTransfers extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconTransfers;
</script>
